export default __webpack_public_path__ + "static/media/grass.22914ff4.jpg";